import Loader from "@/components/loader/Loader.vue";
import html2canvas from "html2canvas";

import VueHtml2pdf from 'vue-html2pdf';
import PrintableReportResidents360Settings from "../resident360-settings/PrintableReportResidents360Settings.vue";
import Report360View from "@/views/reports/reports-views/report-360/report-360-view/Report360View.vue";
import { reportPeriods } from "@/consts/reportPeriods";
import Report360ViewMedia from "@/views/reports/reports-views/report-360/report-360-view-media/Report360ViewMedia.vue";
import Report360ViewServices from "@/views/reports/reports-views/report-360/report-360-view-services/Report360ViewServices.vue";
import Report360ViewEvents from "@/views/reports/reports-views/report-360/report-360-view-events/Report360ViewEvents.vue";

export default {
  name: "PrintableResidentReport360",
  components: {
    Loader,
    Report360View,
    Report360ViewMedia,
    Report360ViewEvents,
    Report360ViewServices,
    PrintableReportResidents360Settings,
    VueHtml2pdf
  },
  data() {
    return {
      residentId: this.$route.params.residentId,
      isLoadingReportPrint: false,
      allDayEvents: [],
      isDisplayAMPM: true,
      isMeals: true,
      isMealsEventsFinish: false,
      mealsEvents: [],
      paperFormat: "a4",
      isPdfGenerating: false,
      locations: [],
      residentImageUrl: null,
      facilityLogo: "data:image/png;base64,",
      pdfOrientation: "portrait",
      printListEventsAll: [],
      printListEvents: [],
      printReportPeriod: reportPeriods[2].value,
      filename:'',
      pagination: {
        from: 0,
        to: 4,
        current_page: 1,
        per_page: 4,
        total: 0,
        pages: 1
      },
      printReportsScreens: [],
      today: null,
      focus: '',
      isDatePositionRight: true,
      isReport360ViewDataLoaded: false,
      isReport360ViewMediaDataLoaded: false,
      isReport360ViewServicesDataLoaded: false,
      isReport360ViewEventsDataLoaded: false,
    }
  },
  computed: {
    resident() {
      return this.$store.state.residentModule.currentResident;
    },
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    isLocalhost() {
      return window.location.hostname === 'localhost';
    },
    isReportLoading() {
      return !this.isReport360ViewDataLoaded || !this.isReport360ViewMediaDataLoaded 
      || !this.isReport360ViewServicesDataLoaded || !this.isReport360ViewEventsDataLoaded
    }
  },
  async created(){
    this.filename = `Resident Report 360 - ${this.resident.name} ${this.resident.pname?.length?`(${this.resident.pname})`:''}`
    await this.$store.dispatch("getResident", this.residentId)
  },
  methods: {
    async generatePdf() {
      this.isPdfGenerating = true;
        try {
          setTimeout(async ()=>{
            await this.$refs.html2Pdf.generatePdf();
          }, 200)
        } catch (error) {
          console.error(error)
        }
        finally {
          this.isPdfGenerating = false
        }
    },
    report360ViewDataLoaded(){
      this.isReport360ViewDataLoaded = true
      console.log('Report360View data loaded')
    },
    report360ViewMediaDataLoaded(){
      this.isReport360ViewMediaDataLoaded = true
      console.log('Report360ViewMedia data loaded')
    },
    report360ViewServicesDataLoaded(){
      this.isReport360ViewServicesDataLoaded = true
      console.log('Report360ViewServices data loaded')
    },
    report360ViewEventsDataLoaded(){
      this.isReport360ViewEventsDataLoaded = true
      console.log('Report360ViewEvents data loaded')
    },
    async onChangePrintReportPeriod(value) {
      this.printReportPeriod = value
    },
    closePrintableReport() {
      this.$router.push(`/reports/reports360/${this.resident.id}`)
    }
  }
}